export class RegExps {
    static uuid: string = '[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}';
    static time: string = '([01]?[0-9]|2[0-3]):[0-5][0-9]';
    static timeRange: string = `${RegExps.time}-${RegExps.time}`;
}
